import { Component } from '@angular/core';
import { CustomDialogComponent } from '../../shared/custom-dialog/custom-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-email-verification-modal',
  standalone: true,
  imports: [],
  templateUrl: './email-verification-modal.component.html',
  styleUrl: './email-verification-modal.component.css',
})
export class EmailVerificationModalComponent {
  constructor(private dialog: MatDialog, private router: Router) {}

  ngOnInit() {
    this.dialog.open(CustomDialogComponent, {
      data: {
        title: 'E-Mail-Verifizierungs-Hinweis',
        bodyText:
          'Falls du dich mit deinem Privathandy + Arbeitsprofil angemeldet hast, kehre bitte wieder in deinen Privat-Browser zurück und aktualisiere die iWuzzler Page.',
        onConfirm: () => {
          this.router.navigate(['/score-table']);
        },
      },
    });
  }
}
